<style scoped>

</style>

<template>
  <span>
    <slot slot-scope="scope"></slot>
    <mu-dialog :title="title" scrollable max-width="100%" width="480px" :esc-press-close="false" :overlay-close="false" :open.sync="editing">
      <mu-form :model="data" label-position="top" label-width="100">
        <mu-form-item prop="input" :label="$t('playlist.title') + $t('space') + $t('prompt.name')">
          <mu-text-field v-model="data.name"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="textarea" :label="$t('playlist.description')">
          <mu-text-field multi-line :rows="3" :rows-max="6" v-model="data.description"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="radio">
          <mu-radio v-model="data.access_mode" :value="0" :label="$t('playlist.accessModeOpen')"></mu-radio>
          <mu-radio v-model="data.access_mode" :value="1" :label="$t('playlist.accessModeClose')"></mu-radio>
          <mu-radio v-model="data.access_mode" :value="2" :label="$t('playlist.accessModeTime')"></mu-radio>
          <mu-date-input v-model="data.can_access_by" v-if="data.access_mode === 2" type="dateTime"></mu-date-input>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click.prevent="onActionEdit" :disabled="isPlaylistNameEmpty"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('button.delete') + $t('space') + $t('playlist.title')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="deleting">
        {{stringDelete}}
        <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
        <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
  </span>
</template>

<script>

export default {
  name: 'ManagePlaylist',
  props: {
    value: {
      type: Object,
      default() {
        return {
          name: "",
          description: "",
          access_mode: 0
        };
      }
    },
    editing: {
      type: Boolean,
      default: false
    },
    deleting: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    create: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      data: JSON.parse(JSON.stringify(this.value)),
    }
  },
  computed: {
    // Flag
    isPlaylistNameEmpty() {
      return this.data.name === '';
    },
    // String
    stringDelete() {
      return this.$t('prompt.deleteMsg', { name: this.data.name });
    },
  },
  watch: {
    data: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true
    },
    value: {
      handler(newValue) {
        if(typeof this.data._id !== 'undefined' && this.data._id !== newValue._id) {
          this.data = JSON.parse(JSON.stringify(this.value))
        }
      },
      deep: true
    },
    editing(newValue) {
      if(this.create && newValue) {
        this.data = {
          name: "",
          description: "",
          access_mode: 0
        };
      }
    },
  },
  methods: {
    onActionCancel() {
      this.$emit('cancel');
    },
    onActionEdit() {
      this.$emit('save', this.data);
    },
    onActionDelete() {
      this.$emit('delete');
    },
  }
}
</script>
